var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4681 0.500912L17.3776 0.421653C17.0586 0.14317 16.6264 -0.00801525 16.1776 0.000327825C15.7288 0.0076606 15.3037 0.176543 14.9989 0.46653L5.79518 9.26114L5.61422 9.32889L5.43803 9.25798L3.15455 6.92192C2.8237 6.58503 2.34977 6.38379 1.84273 6.36609C1.33547 6.3484 0.842714 6.51826 0.484412 6.83112C-0.0870263 7.33272 -0.162065 8.12211 0.308218 8.69896L5.01897 14.4775C5.2868 14.8061 5.71898 15 6.17974 15H6.59043C7.36548 15 8.09045 14.6685 8.52971 14.1105L17.6774 2.53662C18.1776 1.90356 18.0872 1.04621 17.4681 0.500912Z",
    fill: "#c59d48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTableIcon);
export default __webpack_public_path__ + "static/media/success-table-icon.453fcdf4bd39b1ed49f9ca5ad7276b2a.svg";
export { ForwardRef as ReactComponent };